import api from "../../utils/apiUserCliente";

const BASE_URL = "/api/cliente/pedidos";

export const getPedidosCliente = async () => {
  const res = await api.get(`${BASE_URL}/obtener`);
  return res.data;
};

export const getPedidoDetalleCliente = async (pedidoId) => {
  const res = await api.get(`${BASE_URL}/${pedidoId}/detalle`);
  return res.data;
};